"use client";

import { ChevronRightIcon } from "@heroicons/react/24/outline";

import { BigAudioPlayer } from "@/components/audioPlayers/BigAudioPlayer";
import { useTutorial } from "@/lib/zustand/useTutorial/useTutorial";
import { TutorialSample } from "@/types/types";
import { createActivationKeyDownHandler } from "@/utils/a11y/createActivationKeyDownHandler";

export function SamplePreview({
  tutorialSample,
}: {
  tutorialSample: TutorialSample;
}) {
  const nextStep = useTutorial((state) => state.nextStep);
  const updateTutorialSteps = useTutorial((state) => state.updateTutorialSteps);

  const handleSelect = () => {
    updateTutorialSteps(tutorialSample);

    nextStep();
  };

  return (
    <div
      // Not a <button>: BigAudioPlayer renders its own button inside, and buttons cannot nest
      role="button"
      tabIndex={0}
      className="flex cursor-pointer items-center gap-x-4 rounded-lg bg-primaryLight/70 p-2 shadow-sm ring-1 ring-gray-900/5 transition-colors hover:bg-primaryLight focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary"
      onClick={handleSelect}
      onKeyDown={createActivationKeyDownHandler(handleSelect)}
    >
      <BigAudioPlayer
        source={tutorialSample.inputFile}
        includePreviewText={false}
        bigWaves={false}
        filename={tutorialSample.genre}
        className="w-full"
      />

      <ChevronRightIcon className="h-6" />
    </div>
  );
}
